import { useState } from "react";
import { saveCostCenterOfficeMapping } from "../Api/CostCenterOfficeMapping";
import {
  Accordion,
  AccordionItem,
  AccordionBody,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const CostCenterOfficeMapping = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [mappingData, setMappingData] = useState({
    costCenter: "",
    officeCode: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMappingData({
      ...mappingData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveCostCenterOfficeMapping(mappingData, userId);
      toast.success(`🦄 Mapping Added Successfully`);
      setMappingData({
        costCenter: "",
        officeCode: "",
      });
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save mapping"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container cost-center-office-mapping-fields">
        <h2 className="fields-title">Cost Center Office Mapping</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0" className="cost-center-office-mapping-master-accordion">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Cost Center <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="costCenter"
                        value={mappingData.costCenter}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Office Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="officeCode"
                        value={mappingData.officeCode}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button variant="primary" type="submit" className="fields-submit">
              Save Mapping
            </Button>
          </div>
        </Form>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default CostCenterOfficeMapping;
